import { render, staticRenderFns } from "./NecessidadeInsumos.vue?vue&type=template&id=035249eb&scoped=true"
import script from "./NecessidadeInsumos.vue?vue&type=script&lang=js"
export * from "./NecessidadeInsumos.vue?vue&type=script&lang=js"
import style0 from "./NecessidadeInsumos.vue?vue&type=style&index=0&id=035249eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035249eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
